/**
 * Issue #341 — 题目纠错 / 优化建议处理 API 客户端。
 *   GET  /admin/question-corrections            列表（状态 / 关键词 / 分页）   —— MANAGER+
 *   GET  /admin/question-corrections/stats       待处理数量                     —— MANAGER+
 *   GET  /admin/question-corrections/:id          详情                          —— MANAGER+
 *   POST /admin/question-corrections/:id/accept   采纳并修改知识库               —— ADMIN+
 *   POST /admin/question-corrections/:id/reject   驳回                          —— ADMIN+
 *   POST /admin/question-corrections/:id/ignore   忽略                          —— ADMIN+
 *
 * 类型契约的唯一来源(SSOT)是 apps/api/openapi.yaml，经 `pnpm codegen` 生成到
 * ./generated/types.ts；本模块只做派生，禁止手写字段定义。
 */
import { apiClient } from './api';
import type { components, operations } from './generated/types';

export type CorrectionStatus = components['schemas']['MyCorrectionView']['status'];
export type CorrectionListItem = components['schemas']['AdminCorrectionListItem'];
export type CorrectionsListResult = components['schemas']['AdminCorrectionListResponse'];
export type CorrectionStats = components['schemas']['CorrectionStats'];
export type AcceptCorrectionInput = components['schemas']['AcceptCorrectionRequest'];
export type CorrectionsListQuery = NonNullable<
  operations['QuestionCorrectionsAdminController_list']['parameters']['query']
>;

export function listCorrectionsApi(
  query: CorrectionsListQuery = {},
): Promise<CorrectionsListResult> {
  return apiClient.get<CorrectionsListResult>(
    '/admin/question-corrections',
    query as unknown as Record<string, unknown>,
  );
}

export function getCorrectionStatsApi(): Promise<CorrectionStats> {
  return apiClient.get<CorrectionStats>('/admin/question-corrections/stats');
}

export function getCorrectionApi(id: string): Promise<CorrectionListItem> {
  return apiClient.get<CorrectionListItem>(
    `/admin/question-corrections/${encodeURIComponent(id)}`,
  );
}

export function acceptCorrectionApi(
  id: string,
  body: AcceptCorrectionInput,
): Promise<CorrectionListItem> {
  return apiClient.post<CorrectionListItem>(
    `/admin/question-corrections/${encodeURIComponent(id)}/accept`,
    body,
  );
}

export function rejectCorrectionApi(id: string, note: string): Promise<CorrectionListItem> {
  return apiClient.post<CorrectionListItem>(
    `/admin/question-corrections/${encodeURIComponent(id)}/reject`,
    { note },
  );
}

export function ignoreCorrectionApi(id: string, note?: string): Promise<CorrectionListItem> {
  return apiClient.post<CorrectionListItem>(
    `/admin/question-corrections/${encodeURIComponent(id)}/ignore`,
    { note },
  );
}
